export const SearchSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" className="svg-search-icon">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 9.5C2 5.358 5.357 2 9.5 2C13.643 2 17 5.358 17 9.5C17 11.3915 16.3002 13.1192 15.1454 14.4384L19.9998 19.2928L19.2928 19.9998L14.4384 15.1454C13.1192 16.3002 11.3915 17 9.5 17C5.357 17 2 13.643 2 9.5ZM16 9.5C16 5.916 13.084 3 9.5 3C5.916 3 3 5.916 3 9.5C3 13.084 5.916 16 9.5 16C13.084 16 16 13.084 16 9.5Z"
        />
    </svg>
);
